import { Component } from "@angular/core";

@Component({
    selector: "wk-icon-member-sprite-pds3",
    templateUrl: "./wk-icon-member-sprite-pds3.html",
    host: { class: "cg3-host-wk-icon-member-sprite" },
})
export class WkIconMemberSpritePds3 {}
